import { render, staticRenderFns } from "./ladderLogList.vue?vue&type=template&id=5839c2c3&scoped=true"
import script from "./ladderLogList.vue?vue&type=script&lang=js"
export * from "./ladderLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5839c2c3",
  null
  
)

export default component.exports